import { render, staticRenderFns } from "./RedPillVoiceEngine.vue?vue&type=template&id=8e905d1e"
import script from "./RedPillVoiceEngine.vue?vue&type=script&lang=js"
export * from "./RedPillVoiceEngine.vue?vue&type=script&lang=js"
import style0 from "./RedPillVoiceEngine.vue?vue&type=style&index=0&id=8e905d1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports